import React from "react";
import PlayerBoxView from "../../Pages/Pokemon/PlayerBoxView";

const PlayerProfileBoxTab = ({ username }) => {
  return (
    <div style={{ marginTop: "-5rem" }}>
      <PlayerBoxView username={username} />
    </div>
  );
};

export default PlayerProfileBoxTab;
